import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"

import "./image.vue?vue&type=style&index=0&id=40cad696&lang=scss"

const __exports__ = script;

export default __exports__